document.addEventListener("DOMContentLoaded", async function () {
  // Mapa tylko po polsku, pierwszy pasujący wygrywa
  const mapaKolorow = [
    ["biel", "#FFFFFF"],
    ["neon", "#EAC7D0"],
    ["klasycz", "#D9B5B8"],
    ["jasny", "#CF9B63"],
    ["średni", "#966C43"],
    ["ciemny", "#775039"],
    ["soczy", "#E99B67"],
    ["natural", "#E68F1A"],
    ["inten", "#FF8331"],
    ["pastel", "#C6DCCA"],
    ["morski", "#74C3CC"],
  ];

  const kolorDomyslny = "#ccc";
  const jezykBazowy = "pl";
  const selektor = ".hero__table__row";

  const wiersze = document.querySelectorAll(selektor);
  if (!wiersze.length) return;

  // Wiersze w języku bazowym (na stronie PL to po prostu bieżące)
  let bazowe = wiersze;

  if (!Shopify.locale.toLowerCase().startsWith(jezykBazowy)) {
    try {
      const root = Shopify.routes.root; // np. "/es/"
      let sciezka = location.pathname;
      if (root !== "/" && sciezka.startsWith(root)) {
        sciezka = "/" + sciezka.slice(root.length);
      }
      const res = await fetch(sciezka + location.search);
      const doc = new DOMParser().parseFromString(await res.text(), "text/html");
      bazowe = doc.querySelectorAll(selektor);
    } catch (e) {
      return;
    }
  }

  wiersze.forEach((wiersz, i) => {
    const tresc = wiersz.querySelector(".hero__table__cell--content p");
    const wzor = bazowe[i];
    if (!tresc || !wzor) return;

    const tytulPl = (wzor.querySelector(".hero__table__cell--title p")?.textContent || "").toLowerCase();
    const trescPl = (wzor.querySelector(".hero__table__cell--content p")?.textContent || "").toLowerCase();

    if (!tytulPl.includes("kolor")) return;

    const znaleziona = mapaKolorow.find(([fragment]) => trescPl.includes(fragment));
    tresc.style.setProperty("--dot-color", znaleziona ? znaleziona[1] : kolorDomyslny);
  });
});







// tagi produktu są oznaczane klasą .is-tags-block bezpośrednio w main-product.liquid

/* No i sierotki na razie nie ma czasu ale trzeba się z tym zmierzyć - propozyszyn :)
document.addEventListener('DOMContentLoaded', function() {
  // Spójniki i reszta hłamu
  const sierotki = /(^|\s)([aiouwz]|do|na|po|za|ze|od|to|że|by|co|bo|aż|ku|nad|pod|przy|dla|lub|albo|oraz|czy|ale|już|nie)\s/gi;
  
  // Selektory miejsc gdzie zaatakować
  const selektory = [
    'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li',
    '.skladnik-item__opis', '.skladnik-item__nazwa',
    '.product__description', '.product-description',
    '.rte', '.metafield-rich_text_field'
  ].join(', ');
  
  document.querySelectorAll(selektory).forEach(element => {
    // jak coś ma kod odpuszczamy
    if (element.querySelector('code, pre, script, style')) return;
    
    // Iterujemy po węzłach tekstowych
    const przechodnik = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    const wezlyTekstowe = [];
    let wezel;
    while ((wezel = przechodnik.nextNode())) {
      wezlyTekstowe.push(wezel);
    }
    
    wezlyTekstowe.forEach(wezelTekstowy => {
      const zamieniony = wezelTekstowy.nodeValue.replace(sierotki, '$1$2\u00A0');
      if (zamieniony !== wezelTekstowy.nodeValue) {
        wezelTekstowy.nodeValue = zamieniony;
      }
    });
  });
});
*/




/* Localized DPD Pickup cart widget labels and country names. */
(() => {
  const translations = {
    pl: {
      label: 'Wybierz kraj wysyłki:',
      placeholder: 'Wybierz kraj *',
      button: 'Wybierz punkt DPD Pickup',
      info: 'Jeżeli chcesz wybrać inny sposób dostawy niż do punktu DPD Pickup, pomiń ten krok i wybierz preferowaną metodę wysyłki na stronie finalizacji zamówienia.',
      countries: { AT: 'Austria', BE: 'Belgia', BG: 'Bułgaria', HR: 'Chorwacja', CZ: 'Czechy', DK: 'Dania', EE: 'Estonia', FI: 'Finlandia', FR: 'Francja', GR: 'Grecja', ES: 'Hiszpania', NL: 'Holandia', IE: 'Irlandia', LT: 'Litwa', LV: 'Łotwa', LU: 'Luksemburg', DE: 'Niemcy', PL: 'Polska', PT: 'Portugalia', RO: 'Rumunia', SK: 'Słowacja', SI: 'Słowenia', SE: 'Szwecja', HU: 'Węgry', IT: 'Włochy' }
    },
    en: {
      label: 'Choose your delivery country:',
      placeholder: 'Choose country *',
      button: 'Choose a DPD Pickup point',
      info: 'If you prefer a delivery method other than a DPD Pickup point, skip this step and choose your preferred delivery method during checkout.',
      countries: { AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria', HR: 'Croatia', CZ: 'Czech Republic', DK: 'Denmark', EE: 'Estonia', FI: 'Finland', FR: 'France', GR: 'Greece', ES: 'Spain', NL: 'Netherlands', IE: 'Ireland', LT: 'Lithuania', LV: 'Latvia', LU: 'Luxembourg', DE: 'Germany', PL: 'Poland', PT: 'Portugal', RO: 'Romania', SK: 'Slovakia', SI: 'Slovenia', SE: 'Sweden', HU: 'Hungary', IT: 'Italy' }
    },
    fr: {
      label: 'Choisissez le pays de livraison :',
      placeholder: 'Choisissez un pays *',
      button: 'Choisir un point relais DPD Pickup',
      info: 'Si vous souhaitez choisir un autre mode de livraison que le point relais DPD Pickup, ignorez cette étape et sélectionnez votre mode de livraison préféré lors du paiement.',
      countries: { AT: 'Autriche', BE: 'Belgique', BG: 'Bulgarie', HR: 'Croatie', CZ: 'République tchèque', DK: 'Danemark', EE: 'Estonie', FI: 'Finlande', FR: 'France', GR: 'Grèce', ES: 'Espagne', NL: 'Pays-Bas', IE: 'Irlande', LT: 'Lituanie', LV: 'Lettonie', LU: 'Luxembourg', DE: 'Allemagne', PL: 'Pologne', PT: 'Portugal', RO: 'Roumanie', SK: 'Slovaquie', SI: 'Slovénie', SE: 'Suède', HU: 'Hongrie', IT: 'Italie' }
    },
    cs: {
      label: 'Vyberte zemi doručení:',
      placeholder: 'Vyberte zemi *',
      button: 'Vyberte výdejní místo DPD Pickup',
      info: 'Pokud chcete zvolit jiný způsob doručení než výdejní místo DPD Pickup, tento krok přeskočte a při dokončení objednávky vyberte preferovaný způsob doručení.',
      countries: { AT: 'Rakousko', BE: 'Belgie', BG: 'Bulharsko', HR: 'Chorvatsko', CZ: 'Česko', DK: 'Dánsko', EE: 'Estonsko', FI: 'Finsko', FR: 'Francie', GR: 'Řecko', ES: 'Španělsko', NL: 'Nizozemsko', IE: 'Irsko', LT: 'Litva', LV: 'Lotyšsko', LU: 'Lucembursko', DE: 'Německo', PL: 'Polsko', PT: 'Portugalsko', RO: 'Rumunsko', SK: 'Slovensko', SI: 'Slovinsko', SE: 'Švédsko', HU: 'Maďarsko', IT: 'Itálie' }
    },
    de: {
      label: 'Wählen Sie Ihr Lieferland:',
      placeholder: 'Land auswählen *',
      button: 'DPD Pickup-Abholpunkt auswählen',
      info: 'Wenn Sie eine andere Versandart als einen DPD Pickup-Abholpunkt wählen möchten, überspringen Sie diesen Schritt und wählen Sie Ihre bevorzugte Versandart beim Checkout.',
      countries: { AT: 'Österreich', BE: 'Belgien', BG: 'Bulgarien', HR: 'Kroatien', CZ: 'Tschechien', DK: 'Dänemark', EE: 'Estland', FI: 'Finnland', FR: 'Frankreich', GR: 'Griechenland', ES: 'Spanien', NL: 'Niederlande', IE: 'Irland', LT: 'Litauen', LV: 'Lettland', LU: 'Luxemburg', DE: 'Deutschland', PL: 'Polen', PT: 'Portugal', RO: 'Rumänien', SK: 'Slowakei', SI: 'Slowenien', SE: 'Schweden', HU: 'Ungarn', IT: 'Italien' }
    },
    es: {
      label: 'Elige el país de envío:',
      placeholder: 'Elige un país *',
      button: 'Elige un punto DPD Pickup',
      info: 'Si prefieres otro método de envío distinto de un punto DPD Pickup, omite este paso y elige el método de envío que prefieras durante el pago.',
      countries: { AT: 'Austria', BE: 'Bélgica', BG: 'Bulgaria', HR: 'Croacia', CZ: 'Chequia', DK: 'Dinamarca', EE: 'Estonia', FI: 'Finlandia', FR: 'Francia', GR: 'Grecia', ES: 'España', NL: 'Países Bajos', IE: 'Irlanda', LT: 'Lituania', LV: 'Letonia', LU: 'Luxemburgo', DE: 'Alemania', PL: 'Polonia', PT: 'Portugal', RO: 'Rumanía', SK: 'Eslovaquia', SI: 'Eslovenia', SE: 'Suecia', HU: 'Hungría', IT: 'Italia' }
    }
  };

  const language = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const copy = translations[language] || translations.en;

  const applyLocalization = (widget) => {
    if (!widget) return;

    if (widget.dataset.countrySelectorText !== copy.label) widget.dataset.countrySelectorText = copy.label;
    if (widget.dataset.messageOpeningButton !== copy.button) widget.dataset.messageOpeningButton = copy.button;
    if (widget.dataset.additionalInfoText !== copy.info) widget.dataset.additionalInfoText = copy.info;

    Object.entries(copy.countries).forEach(([code, name]) => {
      const key = `countryName${code.charAt(0)}${code.slice(1).toLowerCase()}`;
      if (widget.dataset[key] !== name) widget.dataset[key] = name;
    });

    const label = widget.querySelector('.pp-country-selector-label');
    if (label && label.textContent !== copy.label) label.textContent = copy.label;

    const select = widget.querySelector('.pp-country-selector select');
    if (select) {
      Array.from(select.options).forEach((option) => {
        const text = !option.value ? copy.placeholder : copy.countries[option.value];
        if (text && option.textContent !== text) option.textContent = text;
      });
    }

    const button = widget.querySelector('.oct-choose-point-button');
    if (button && button.textContent !== copy.button) button.textContent = copy.button;

    const info = widget.querySelector('.pp-additional-info');
    if (info && info.textContent !== copy.info) info.textContent = copy.info;

    widget.dataset.dpdLocaleApplied = language;
  };

  const applyAll = () => document.querySelectorAll('.js--map-cart-widget').forEach(applyLocalization);

  document.addEventListener('DOMContentLoaded', () => {
    applyAll();
    new MutationObserver(applyAll).observe(document.body, { childList: true, subtree: true });
  });
})();


/* Delivery-method choice in cart: shown in every storefront language. The DPD app keeps handling the selected Pickup point. */
(() => {
  const copyByLocale = {
    pl: { legend: 'Wybierz sposób dostawy', courier: 'DPD Kurier', pickup: 'DPD Pickup' },
    en: { legend: 'Choose delivery method', courier: 'DPD Courier', pickup: 'DPD Pickup point' },
    fr: { legend: 'Choisissez le mode de livraison', courier: 'Livraison DPD à domicile', pickup: 'Point relais DPD Pickup' },
    de: { legend: 'Versandart wählen', courier: 'DPD Kurier', pickup: 'DPD Pickup-Abholpunkt' },
    es: { legend: 'Elige el método de envío', courier: 'Entrega a domicilio DPD', pickup: 'Punto DPD Pickup' },
    cs: { legend: 'Vyberte způsob doručení', courier: 'DPD Kurýr', pickup: 'Výdejní místo DPD Pickup' }
  };
  const locale = (window.Shopify?.locale || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const copy = copyByLocale[locale] || copyByLocale.en;
  const mount = () => {
    const widget = document.querySelector('.js--map-cart-widget');
    if (!widget || document.querySelector('[data-dpd-method-choice]')) return;
    const choice = document.createElement('fieldset');
    choice.dataset.dpdMethodChoice = 'true';
    choice.style.cssText = 'margin:0 0 16px;padding:16px;border:1px solid #dedede;background:#fff;display:flex;gap:12px;flex-wrap:wrap;align-items:center';
    choice.innerHTML = '<legend style="width:100%;font-weight:600;margin:0 0 8px">' + copy.legend + '</legend><label style="display:flex;gap:7px;align-items:center;cursor:pointer"><input type="radio" name="dpd-cart-method" value="courier"> ' + copy.courier + '</label><label style="display:flex;gap:7px;align-items:center;cursor:pointer"><input type="radio" name="dpd-cart-method" value="pickup"> ' + copy.pickup + '</label>';
    widget.before(choice);
    const update = (method) => {
      widget.style.display = method === 'pickup' ? '' : 'none';
      window.sessionStorage.setItem('inky_dpd_cart_method', method);
      document.cookie = 'inky_dpd_cart_method=' + method + '; path=/; SameSite=Lax';
    };
    const saved = window.sessionStorage.getItem('inky_dpd_cart_method') || 'courier';
    const selected = choice.querySelector('input[value="' + saved + '"]') || choice.querySelector('input[value="courier"]');
    selected.checked = true;
    update(selected.value);
    choice.addEventListener('change', (event) => {
      if (event.target.name === 'dpd-cart-method') update(event.target.value);
    });
  };
  document.addEventListener('DOMContentLoaded', mount);
  new MutationObserver(mount).observe(document.documentElement, { childList: true, subtree: true });
})();




/* Keep the existing free-shipping layout; only increase message legibility. */
(() => {
  if (document.getElementById('inky-free-shipping-style')) return;
  const style = document.createElement('style');
  style.id = 'inky-free-shipping-style';
  style.textContent = '.wt-free-shipping-bar__text{font-size:16px!important;font-weight:600!important;line-height:1.35!important}';
  document.head.appendChild(style);
})();
